<section class="projects-section">
  <div class="container">

    <div class="card">

      <!-- PAGE HEADER -->
      <div class="page-header">
        <h3 class="page-title">Roles</h3>

        <div class="flex-spacer"></div>

        <button [routerLink]="projectId ? ['/project-roles', projectId, 'create-role'] : ['/create-role']"
          class="icon-btn create">
          <i class="fa-solid fa-plus"></i>
        </button>

      </div>

      <div class="table-wrapper table-mobile-card">

        <table class="table" id="roles-table">
          <thead>
            <tr>
              <th resizableColumn tableId="roles-table" colKey="name">
                Role Name
              </th>

              <th resizableColumn tableId="roles-table" colKey="actions" class="action-col">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>

            <!-- EMPTY STATE -->
            <tr *ngIf="roles.length === 0">
              <td colspan="100%">
                <div class="no-data">
                  <i class="fa-regular fa-folder-open"></i>
                  No roles found
                </div>
              </td>
            </tr>

            <!-- DATA ROWS -->
            <tr *ngFor="let r of roles">

              <td data-label="Role Name">
                {{ r.name }}
              </td>

              <td data-label="Actions" class="action">
                <div class="flex justify-center gap-3">
                  <button class="icon-btn view" (click)="viewRole(r.roleId)">
                    <i class="fa-solid fa-eye"></i>
                  </button>
                </div>
              </td>

            </tr>

          </tbody>
        </table>

        <!-- PAGINATION -->
        <div class="pagination-bar">

          <div class="left">
            <label>Page Size : </label>
            <select [(ngModel)]="size" (change)="changeSize()">
              <option [value]="10">10</option>
              <option [value]="15">15</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
            </select>
          </div>

          <div class="center">
            Page {{ page + 1 }} / {{ totalPages }}
          </div>

          <div class="right">
            <button class="btn-page" (click)="prevPage()" [disabled]="page === 0">←</button>
            <button class="btn-page" (click)="nextPage()" [disabled]="page >= totalPages - 1">→</button>
          </div>

        </div>

      </div>

    </div>

  </div>
</section>